import { useEffect, useState } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { getProfile } from "~/api/auth"
import type { ProfileResponse } from "~/api/auth"

export type LayoutOutletContext = {
  profile: ProfileResponse | null
  /** True until the first getProfile attempt for this pathname finishes (avoids flashing Log in when logged in). */
  authLoading: boolean
}

export function Layout() {
  const location = useLocation()
  const [profile, setProfile] = useState<ProfileResponse | null>(null)
  const [authLoading, setAuthLoading] = useState(true)

  useEffect(() => {
    setAuthLoading(true)
    getProfile()
      .then(setProfile)
      .catch(() => setProfile(null))
      .finally(() => setAuthLoading(false))
  }, [location.pathname])

  return (
    <div className="flex min-h-screen flex-col bg-[var(--color-bg-primary)] text-[var(--color-text-primary)]">
      <Outlet context={{ profile, authLoading }} />
    </div>
  )
}
